import posthog from 'posthog-js'
import { useEffect } from 'react'

import { isAnalyticsConfigured } from './config'

/**
 * Records the session for as long as the calling component is mounted.
 *
 * Replay is disabled globally in `config.ts` and switched on per surface here.
 * Recording the whole admin app would spend the recording quota on screens
 * nobody will watch, and would carry replay's privacy surface into pages that
 * never needed it. The onboarding wizard is the one place where *why* somebody
 * stopped is the entire question.
 *
 * Inputs are masked by the `session_recording` config, not here — masking is a
 * property of the recording, and a surface that opts in must not be able to opt
 * out of it.
 */
export const useSessionReplay = (): void => {
  useEffect(() => {
    if (!isAnalyticsConfigured) return

    posthog.startSessionRecording()

    return () => posthog.stopSessionRecording()
  }, [])
}
